import React from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';

export default class DeviceFinder extends React.Component {
    dialogRef = React.createRef();
    state = {
        editing: false
    };

    render() {
        return (
            <div
                style={{ width: '100%', padding: 10, border: '1px solid black', borderRadius: 5, marginTop: 5 }}
            >
                { this.props.data?.created } - {this.props.data.user.firstName} {this.props.data.user.lastName}<br/>
                { this.props.data?.message }
            </div>
        );
    }
}